import * as typography from './typography'
import * as mediaQueries from './mediaQueries'
import * as colors from './colors'
import * as animations from './animations'
import * as helpers from './helpers'
import * as fonts from './fonts'

const { responsiveStyles } = helpers

// All global styles
const globals = `
  ${ helpers.reset }
  ${ fonts.MaterialIconsFont }
  ${ fonts.GraphikLightFont }
  ${ fonts.GraphikRegularFont }
  ${ fonts.GraphikMediumFont }
  ${ fonts.GraphikSemiboldFont }
  ${ fonts.GraphikBoldFont }
  ${ fonts.GraphikBlackFont }
  ${ fonts.GraphikSuperFont }

  * {
    box-sizing: border-box;
  }

  html {
    font-display: block;
    padding: 0;
    margin: 0;
    color: ${ colors.textColor };
    ${ helpers.fontSmoothing }
    -webkit-text-size-adjust: none;
    text-size-adjust: none;
    &.page-lock {
      position: relative;
      overflow: hidden;
      height: 100%;
    }
    ${ mediaQueries.mediumAndBelow } {
      &.m-page-lock, &.m-page-lock body {
        position: relative;
        overflow: hidden;
        height: 100%;
      }
    }
  }

  body {
    padding: 0;
    margin: 0;
    ${ typography.body }
    color: ${ colors.textColor };
    background: ${ colors.bgColor };
  }

  b, strong {
    font-weight: 600;
  }

  h1, h2, h3, h4, h5, h6, blockquote, p, ul, ol {
    font-weight: normal;
    margin: 0 0 0.5em;
    ${ responsiveStyles('max-width', 1000, 800, 700, 600) }
  }

  h1, h2, h3, h4, h5, h6, blockquote {
    b, strong {
      font-weight: 600;
    }
  }

  p {
    ${ typography.body }
    margin-top: 1.25em;
    margin-bottom: .5em;
    &.small {
      ${ typography.bodySmall }
    }
    &.medium {
      ${ typography.bodyMedium }
    }
    &.large {
      ${ typography.bodyLarge }
    }
    a {
      border-bottom: 1px solid ${ colors.green };
      padding-bottom: .1em;
      &:hover {
        color: ${ colors.green };
      }
    }
  }

  h1, .h1 {
    ${ typography.heading1 }
    ${ responsiveStyles('margin-top', 10, 10, 10, 8) }
    ${ responsiveStyles('margin-bottom', 8, 8, 6, 8) }
  }

  h2, .h2 {
    ${ typography.h2 }
    ${ responsiveStyles('margin-top', 10, 10, 10, 8) }
    ${ responsiveStyles('margin-bottom', 8, 8, 6, 8) }
  }

  h3, .h3 {
    ${ typography.h3 }
    ${ responsiveStyles('margin-top', 10, 10, 10, 8) }
    ${ responsiveStyles('margin-bottom', 0, 0, 6, 8) }
  }

  h4, .h4 {
    ${ typography.h4 }
    ${ responsiveStyles('margin-top', 24, 16, 16, 8) }
    ${ responsiveStyles('margin-bottom', 0, 0, 0, 4) }
  }

  h5, .h5 {
    ${ typography.h5 }
    ${ responsiveStyles('margin-top', 24, 16, 16, 8) }
    font-weight: 700;
    line-height: 1.25em;
    margin-bottom: 0;
  }

  h6, .h6 {
    ${ typography.h6 }
    margin-top: 0;
    ${ responsiveStyles('margin-bottom', 0, 0, 0, 8) }
  }

  figcaption {
    ${ responsiveStyles('margin-top', 20, 12, 10, 4) }
    ${ responsiveStyles('margin-bottom', 4, 4, 2, 4) }
    ${ typography.bodySmall }
    text-transform: uppercase;
    font-weight: bold;
    &.black {
      text-transform: none;
    }
  }

  hr {
    margin: 2em auto;
    border: 0;
    border-bottom: 1px solid ${ colors.lightGrey };
  }

  a {
    color: inherit;
    cursor: pointer;
    text-decoration: none;
    transition: color ${ animations.mediumSpeed } ease-in-out, border ${ animations.mediumSpeed } ease-in-out;
    &.text-link {
      font-size: 14px;
      line-height: 16px;
      font-weight: bold;
      text-decoration: none;
      letter-spacing: 1.75px;
      border-bottom: 1px solid ${ colors.green };
      text-transform: uppercase;
      color: ${ colors.green };
      padding-bottom: 3px;
    }
  }

  // Remove grey rectangle from iOS taps
  a, input, button {
    -webkit-tap-highlight-color: rgba(0,0,0,0);
  }

  img {
    max-width: 100%;
  }

  time {
    ${ typography.bodySmall };
  }

  ::selection {
    background: ${ colors.green };
    color: ${ colors.bgColor };
  }

`
export default globals;
